/*
 * Project: BKN_FRONT
 * Copyright (c) 2024 Nttdata
 */
export const apiUrl = () => {
  const urlFront = window.location.href;
  if (urlFront.includes("localhost")) {
    return "http://localhost:7001/bkint/AppJava";
  } else if (urlFront.includes("preproduccio")) {
    return "https://pre.salut.gencat.cat/bkint/AppJava";
  } else {
    return "https://salut.gencat.cat/bkint/AppJava";
  }
};

export const apiUrlBkintTram = () => {
  const urlFront = window.location.href;
  if (urlFront.includes("localhost")) {
    return "http://localhost:7001/bkint_tram/AppJava";
  } else if (urlFront.includes("preproduccio")) {
    return "https://pre.salut.gencat.cat/bkint_tram/AppJava";
  } else {
    return "https://salut.gencat.cat/bkint_tram/AppJava";
  }
};

//http://localhost:7001/bkint/AppJava/

export const apiUrlFront = () => {
  const urlFront = window.location.href;
  if (urlFront.includes("localhost")) {
    return "https://localhost:3000";
  } else if (urlFront.includes("preproduccio")) {
    return "https://preproduccio.front.bkint.salut.gencat.cat";
  } else {
    return "https://front.bkint.salut.gencat.cat";
  }
};
export const URL_APP = {
  //BKI
  BASE: "/",
  AUTHENTICATOR: "/Authenticator",
  ENVIAMENTS: "/LogsEnviamentsPRE",
  PROPIETATS: "/TablaProperties",
  TRAZABILIDAD: "/Trazabilidad",
  DETALL_TRAMITS: "/DetallTramits",
  METATAULA: "/MantenimentMetataula",
  CONTROL_TRAMITS: "/ControlTramits",
  PATH_XML: "/ConsultaPathsXML",
  //DAs
  MODIFICAR_COORDENADES: "/ModificarCoordenades",
  CONSULTAR_DAS: "/ConsultarDAs",
  ERROR: "/ErrorPage",
  UNATHENTICATED: "/Unathenticated"
};

export const IDLE_URL = apiUrlFront() + "/sessionterminated";

export const URL_BKI = {
  /*PANTALLES BKI*/
  REDIRECT: apiUrl() + "/react/redirectReact",
  VALIDATE_TOKEN: apiUrl() + "/react/validateToken",
  GENERAR_FITXER: apiUrl() + "/GeneraExcel?nomUsuari=",
  ENVIAR_XML: apiUrl() + "/EnviaXML?nomUsuari=",
  CARREGAR_FITXER: apiUrl() + "/CarregarCorregit?nomUsuari=",
  TRACE: apiUrl() + "/react/getTrace?trazaID=",
  TRACES: apiUrl() + "/react/getTraces",
  GET_PROPIETATS: apiUrl() + "/react/getPropietats",
  POST_PROPIETATS: "/react/postPropietats",
  GET_LOGS_EVIAMENTS: apiUrl() + "/react/getLogsEnviaments",
  CONTROL_TRAMITS: apiUrl() + "/react/getControlTramits",
  POST_CONTROL_TRAMITS: apiUrl() + "/react/postControlTramits",
  PATH_XML: apiUrl() + "/react/getPathsXML",
  POST_PATH_XML: apiUrl() + "/react/postPathXML",
  PATH_GET_LIST_TIPUS: apiUrl() + "/react/getListTipus",
  REINICIAR_REINTENTS: apiUrl() + "/react/reiniciarReintents?trazaID=",

  /*PANTALLES RDA*/
  REQDA_URL: apiUrl() + "/recuperarDAs",
  ENVIARDA_URL: apiUrl() + "/enviarDAs",
  ENCRYPT_URL: apiUrl() + "/frontRDADesencryptMsg",
};

export const URL_BKINT_TRAM = {
  REPROCESS_DOCUMENTS_DOCTRAM: apiUrlBkintTram() + "/processadorTramits/executeDOCTRAM/reprocess/errors"
}

export const APP_JSON = "application/json";
export const APP_TEXT = "application/text";
